import commercialFA from './fa/fa.json'

const CommercialMessages = {
  fa: { ...commercialFA },
}

export default CommercialMessages
